export default "__VITE_ASSET__EFpd6bWb__"